import { render, staticRenderFns } from "./pagination.code.md?vue&type=template&id=7b39bb8b&"
import script from "./pagination.code.md?vue&type=script&lang=ts&"
export * from "./pagination.code.md?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../storefront/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports